document.documentElement.classList.remove("no-js");

document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", () => {
      const expanded = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!expanded));
      mobileMenu.hidden = expanded;
      document.body.classList.toggle("panel-open", !expanded);
    });
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const variantInput = form.querySelector("[data-variant-input]");
    const price = form.querySelector("[data-product-price]");
    const buttonPrice = form.querySelector("[data-button-price]");
    const variantButtons = form.querySelectorAll("[data-variant-button]");

    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        variantButtons.forEach((candidate) => {
          candidate.classList.remove("active");
          candidate.setAttribute("aria-pressed", "false");
        });
        button.classList.add("active");
        button.setAttribute("aria-pressed", "true");
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (price) price.textContent = button.dataset.variantPrice;
        if (buttonPrice) buttonPrice.textContent = button.dataset.variantPrice;
      });
    });
  });

  initReviews();
});

async function initReviews() {
  const section = document.querySelector("[data-reviews]");
  if (!section) return;

  const grid = section.querySelector("[data-review-grid]");
  const search = section.querySelector("[data-review-search]");
  const filters = section.querySelector("[data-review-filters]");
  const distribution = section.querySelector("[data-rating-distribution]");
  const results = section.querySelector("[data-review-results]");
  const clear = section.querySelector("[data-review-clear]");
  const more = section.querySelector("[data-reviews-more]");
  const remaining = section.querySelector("[data-reviews-remaining]");
  if (!grid || !filters || !distribution || !results || !more || !remaining) return;

  let reviews = [];
  try {
    const response = await fetch(section.dataset.reviewsUrl);
    if (!response.ok) return;
    reviews = await response.json();
  } catch {
    return;
  }

  const state = { rating: null, query: "", visible: 12 };
  const scores = [5, 4, 3, 2, 1];

  const countFor = (score) => reviews.filter((review) => Number(review.rating) === score).length;
  scores.forEach((score) => {
    const count = countFor(score);
    const row = document.createElement("button");
    row.type = "button";
    row.innerHTML = `<span>${score} star</span><i><b style="width:${reviews.length ? (count / reviews.length) * 100 : 0}%"></b></i><strong>${count}</strong>`;
    row.addEventListener("click", () => setRating(score));
    distribution.appendChild(row);
  });

  const allFilter = createFilter("All", reviews.length, null);
  filters.appendChild(allFilter);
  scores.forEach((score) => filters.appendChild(createFilter(`${score}★`, countFor(score), score)));

  function createFilter(label, count, rating) {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.rating = rating === null ? "all" : String(rating);
    button.innerHTML = `${label} <span>${count}</span>`;
    button.addEventListener("click", () => setRating(rating));
    return button;
  }

  function setRating(rating) {
    state.rating = rating;
    state.visible = 12;
    render();
  }

  function filtered() {
    const query = state.query.toLowerCase().trim();
    return reviews.filter((review) => {
      if (state.rating && Number(review.rating) !== state.rating) return false;
      if (!query) return true;
      return [review.title, review.body, review.reviewer].some((value) => String(value || "").toLowerCase().includes(query));
    });
  }

  function render() {
    const matches = filtered();
    const shown = matches.slice(0, state.visible);
    grid.replaceChildren(...shown.map(reviewCard));
    results.textContent = `Showing ${shown.length} of ${matches.length}`;
    clear.hidden = state.rating === null;
    more.hidden = shown.length >= matches.length;
    remaining.textContent = `${Math.max(0, matches.length - shown.length)} remaining`;
    filters.querySelectorAll("button").forEach((button) => button.classList.toggle("active", button.dataset.rating === (state.rating === null ? "all" : String(state.rating))));
  }

  function reviewCard(review) {
    const card = document.createElement("article");
    card.className = "review-card";
    const top = document.createElement("div");
    top.className = "review-card-topline";
    const stars = document.createElement("span");
    stars.className = "review-stars";
    stars.textContent = "★".repeat(Number(review.rating)) + "☆".repeat(5 - Number(review.rating));
    const date = document.createElement("time");
    date.dateTime = review.createdAt;
    date.textContent = new Date(review.createdAt).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    top.append(stars, date);
    const title = document.createElement("h3");
    title.textContent = review.title || "Customer review";
    const body = document.createElement("p");
    body.className = "review-body";
    body.textContent = review.body || "";
    const footer = document.createElement("div");
    footer.className = "review-card-footer";
    const reviewer = document.createElement("strong");
    reviewer.textContent = review.reviewer || "Verified customer";
    const badges = document.createElement("div");
    if (review.verifiedBuyer) badges.appendChild(badge("Verified buyer"));
    if (review.incentivized) badges.appendChild(badge("Incentivized review"));
    footer.append(reviewer, badges);
    card.append(top, title, body, footer);
    return card;
  }

  function badge(text) {
    const badge = document.createElement("span");
    badge.textContent = text;
    return badge;
  }

  search?.addEventListener("input", (event) => {
    state.query = event.target.value;
    state.visible = 12;
    render();
  });
  clear?.addEventListener("click", () => setRating(null));
  more.addEventListener("click", () => {
    state.visible += 12;
    render();
  });
  render();
}

/* ===== Phase 2: reveal, desktop buybar, quick add, facets, real-review voices ===== */
document.addEventListener("DOMContentLoaded", () => {
  initReveal();
  initDeskBuybar();
  initQuickAdd();
  initFacets();
  initVoices();
});

function initReveal() {
  if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const selector = ".cpg-section, .cpg-standard, .cpg-feature, .cpg-certs, .cpg-voices, .cmp, .fx-home, .cpg-final-cta, .product-ritual, .ingredients-section, .use-testing-grid, .faq-section, .reviews-section, .collection-guide";
  const els = [...document.querySelectorAll(selector)].filter((el) => el.getBoundingClientRect().top > window.innerHeight * 0.85);
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add("is-in"); io.unobserve(entry.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
  els.forEach((el) => { el.classList.add("reveal"); io.observe(el); });
  const fallback = () => {
    els.forEach((el) => { if (!el.classList.contains("is-in") && el.getBoundingClientRect().top < window.innerHeight) el.classList.add("is-in"); });
  };
  window.addEventListener("scroll", fallback, { passive: true });
  window.setTimeout(fallback, 1500);
}

function initDeskBuybar() {
  const bar = document.querySelector("[data-desk-buybar]");
  const panel = document.querySelector(".purchase-panel");
  const form = document.querySelector("[data-product-form]");
  if (!bar || !panel || !form) return;
  const update = () => {
    const passed = panel.getBoundingClientRect().bottom < 0;
    bar.classList.toggle("is-visible", passed);
    bar.setAttribute("aria-hidden", String(!passed));
  };
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update, { passive: true });
  update();
  bar.querySelector("[data-desk-add]")?.addEventListener("click", () => {
    if (typeof form.requestSubmit === "function") form.requestSubmit(); else form.submit();
  });
  const price = bar.querySelector("[data-desk-price]");
  form.querySelectorAll("[data-variant-button]").forEach((button) => {
    button.addEventListener("click", () => { if (price) price.textContent = button.dataset.variantPrice; });
  });
}

function initQuickAdd() {
  document.querySelectorAll("[data-quick-add]").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      const id = Number(button.dataset.quickAdd);
      const label = button.innerHTML;
      button.disabled = true; button.textContent = "Adding…";
      try {
        const add = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
        if (!add.ok) throw new Error("add failed");
        const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
        document.querySelectorAll("[data-cart-count]").forEach((el) => { el.textContent = `(${cart.item_count})`; });
        button.textContent = "Added to bag ✓"; button.classList.add("is-added");
        setTimeout(() => { button.innerHTML = label; button.classList.remove("is-added"); button.disabled = false; }, 2400);
      } catch {
        button.textContent = "Try again"; button.disabled = false;
      }
    });
  });
}

function initFacets() {
  const bar = document.querySelector("[data-facets]");
  if (!bar) return;
  const cells = [...document.querySelectorAll(".product-card-cell")];
  const count = bar.querySelector("[data-facet-count]");
  const state = { format: "all", goal: "all", thc: "all" };
  const apply = () => {
    let shown = 0;
    cells.forEach((cell) => {
      const ok = Object.keys(state).every((key) => state[key] === "all" || cell.dataset[key] === state[key]);
      cell.hidden = !ok; if (ok) shown += 1;
    });
    if (count) count.textContent = `${shown} formulation${shown === 1 ? "" : "s"}`;
  };
  bar.querySelectorAll(".facet-group").forEach((group) => {
    const key = group.dataset.facet;
    group.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", () => {
        state[key] = button.dataset.value;
        group.querySelectorAll("button").forEach((b) => b.classList.toggle("active", b === button));
        apply();
      });
    });
  });
  apply();
}

async function initVoices() {
  const section = document.querySelector("[data-voices-json]");
  if (!section) return;
  try {
    const response = await fetch(section.dataset.voicesJson);
    if (!response.ok) return;
    const reviews = await response.json();
    // Real reviews only: 5-star, verified, readable length, and no medical-condition language
    // (the brand does not adopt disease claims by featuring them). Incentivized reviews are
    // kept but disclosed on the card, matching the product page feed.
    const medical = /pain|anxiet|depress|arthrit|cure|treat|disease|inflamm|insomnia|migraine|cancer|medic/i;
    const picks = reviews
      .filter((r) => Number(r.rating) === 5 && r.verifiedBuyer && (r.body || "").length >= 40 && (r.body || "").length <= 240 && !medical.test(`${r.title || ""} ${r.body || ""}`))
      .slice(0, 3);
    if (picks.length < 3) return;
    const grid = section.querySelector("[data-voices-grid]");
    grid.replaceChildren(...picks.map((review) => {
      const card = document.createElement("article");
      card.className = "cpg-voice";
      const stars = document.createElement("div"); stars.className = "cpg-voice-stars"; stars.setAttribute("aria-hidden", "true"); stars.textContent = "★★★★★";
      const title = document.createElement("h3"); title.textContent = review.title || "Customer review";
      const body = document.createElement("p"); body.textContent = review.body || "";
      const by = document.createElement("div"); by.className = "cpg-voice-by";
      const name = document.createElement("b"); name.textContent = review.reviewer || "Verified customer";
      const badge = document.createElement("span"); badge.textContent = review.incentivized ? "· Verified buyer · Incentivized review" : "· Verified buyer";
      by.append(name, badge); card.append(stars, title, body, by);
      return card;
    }));
    section.hidden = false;
  } catch { /* leave hidden */ }
}
